/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-height',
  templateUrl: './height.page.html',
  styleUrls: ['./height.page.scss'],
})
export class HeightPage implements OnInit {

  protected heightValueCm : number;
  protected heightValueFoot!: number;
  protected heightValueInch! : number;

  protected saveChangesButton : boolean = false;

  protected nextButtonHidden : boolean = true;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected newOption : any;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected userData : any;

  protected firstSetup : boolean;

  constructor(public modalCtrl: ModalController, public navParams: NavParams) {
    this.userData = this.navParams.get('theSoul'); //getting 'user' data
    this.newOption = this.userData.height;
    this.firstSetup = this.navParams.get('firstSetup');
    
    if(this.newOption == null){
      this.newOption = 170;
    }
    this.heightValueCm = this.newOption;
    this.setHeightScale()
    
  }
  ngOnInit(): void {
  }

  //converts current height to foot and inches
  setHeightScale(){
    this.heightValueFoot = this.heightValueCm * 0.0328084 | 0;  //cm -> feet
    this.heightValueInch = ((this.heightValueCm * 0.0328084) - this.heightValueFoot) * 12 | 0; //feet -> inches
    
    this.showSaveButton();

    return ((this.heightValueCm / 100) + " m / " + this.heightValueFoot + "'" + this.heightValueInch);
  }

  //closes modal without saving
  exitButton(){
    this.modalCtrl.dismiss('exitModal');
  }

  //switches 'exitButton' to 'saveButton'
  showSaveButton(){
    this.saveChangesButton = true;
  }

  //saves changes made by user
  saveButton(){
    this.savesOption();
    this.exitButton();
  }

  //"goes back" 1 modal and saves info
  backButton(){
    this.savesOption();
    this.modalCtrl.dismiss('backModal');
  }

  //saves info and closes modal
  nextButton(){

    this.savesOption();
    
    //alert(this.newOption + " cm | "+ this.heightValueFoot+"feet & " + this.heightValueInch+" inches");

    this.modalCtrl.dismiss('nextModal');
  }

  savesOption(){
    this.userData.height = this.heightValueCm;
    //console.log("settado: ", this.userData.height);
  }

  /** Clears the height and closes the modal (userData is updated by reference). */
  clearHeight(){
    this.userData.height = null;
    this.modalCtrl.dismiss('exitModal');
  }

  //sets 'genericOption'
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setOption(newOption : any){
    this.newOption = newOption;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad HeightPage');
  }
}
